module.exports = __webpack_public_path__ + "static/media/smarthealth.c3ca62dd.jpg";